<template>
    <v-dialog v-model="dialog" max-width="705" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="py-8 px-11" :loading="loadingRequest">
            <v-row justify="end" class="ma-0">
                <v-btn icon>
                    <v-icon @click="dialog = false">mdi-close</v-icon>
                </v-btn>
            </v-row>
            <h2 class="text-center">{{lesson.title}}</h2>
            <p class="font-weight-bold mt-10" v-html="lesson.description"></p>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ['lesson_id'],
        data(){
            return {
                dialog: false,
                lesson: {},
                loadingRequest: false,
            }
        },

        watch: {
            lesson_id: function (newVal) {
                if(newVal)
                    this.loadingRequest = true;
                    this.$api('lessons').show(this.lesson_id).then(res => {
                        this.lesson = res.data.lesson;
                    }).finally(() => {
                        this.loadingRequest = false;
                    })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/components/show";
</style>